export default __webpack_public_path__ + "static/media/products1.f851986f.png";